
export default {

  selectLrningList: { // 학습중 리스트
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/lrning'
  },

  selectAplList: { // 학습신청중 리스트
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/apl'
  },

  selectCmpList: { // 학습완료 리스트
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/cmp'
  },

  selectCancList: { // 학습취소 리스트
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/canc'
  },

  selectTooltip: { // 과정상세정보 튤팁
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/mySpace/tooltip'
  },

  getLearningCertList: { // 학습확인증조회
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/mySpace/myEduConfPopup'
  },

  getApplyInfoModalList: { // 신청정보조회
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/mySpace/myLrnAplPopup'
  },

  getLrnDtmEditPopupList: { // 학습일변경 최초실행
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/mySpace/lrnDtmEditPopup'
  },

  updateLrnDtmTrt: { // 학습일변경 처리
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/popup/lrnDtmTrt'
  },

  getStudyToken: {
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/getStudyToken'
    // url: 'mrm/v1/security/selectSsuLearnSysInfo'
  },

  getCancPsbYn: { // 학습 입과취소 가능여부
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/mySpace/cancPsbYn'
  },

  getLrnCancelPopupList: { // 학습취소 라디오선택 내역
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/mySpace/lrnCancelPopup'
  },

  updateLrnCancApl: { // 학습취소 처리
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/lrnApl/lrnCancApl'
  },

  getMyCrcmpCertiPopupList: { // 수료증 로딩
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/myCrcmpCertiPopup'
  },

  getMmyCrcmpCertiEnglish: { // 영문이름 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/sub/myCrcmpCertiEnglish'
  },

  updateMyEnglishNameSave: { // 영문이름 수정 처리
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/popup/myEnglishNameSave'
  },

  getMyEstPopupList: { // 견적서 조회
    method: 'GET',
    showSpinner: false, // 스피너 OFF
    url: 'mrm/v1/permit/nrw/mySpace/sub/myEstPopup'
  }

}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/lrningApi.js